import { useQuery as c } from "@tanstack/vue-query";
import { computed as i, toValue as s } from "vue";
const o = ["creative-group"], l = {
  all: o,
  byCampaign: (e) => [...o, "campaign", e],
  list: (e) => [...o, "campaign", e, "list"],
  detail: (e, r) => [...o, "campaign", e, "detail", r]
}, q = (e, r, t) => {
  const n = i(() => l.list(s(r).campaignId));
  return c({
    ...t,
    queryKey: n,
    queryFn: async () => {
      const a = s(r);
      return e.creativeGroup.findAll({ campaignId: a.campaignId });
    }
  });
}, I = (e, r, t) => {
  const n = i(() => {
    const a = s(r);
    return l.detail(a.campaignId, a.creativeGroupId);
  });
  return c({
    ...t,
    queryKey: n,
    queryFn: async () => {
      const a = s(r);
      return e.creativeGroup.findOne({ creativeGroupId: a.creativeGroupId });
    }
  });
}, K = async (e, r, t) => {
  await e.prefetchQuery({
    queryKey: l.list(t.campaignId),
    queryFn: async () => r.creativeGroup.findAll(t)
  });
}, L = async (e, r, t) => {
  await e.prefetchQuery({
    queryKey: l.detail(t.campaignId, t.creativeGroupId),
    queryFn: async () => r.creativeGroup.findOne({ creativeGroupId: t.creativeGroupId })
  });
}, y = ["creative"], u = ["landing"], p = {
  all: y,
  list: (e) => [...y, "list", e]
}, d = {
  all: () => ["advert-labels"]
}, v = {
  all: u,
  list: (e) => [...u, "list", e]
}, m = {
  all: [...u, "group"],
  list: (e) => [...u, "group", "list", e]
}, f = (e, r, t) => {
  const n = i(() => p.list(s(r)));
  return c({
    ...t,
    queryKey: n,
    queryFn: async () => {
      const a = s(r);
      return e.creatives.list(a);
    }
  });
}, A = (e, r, t) => {
  const n = i(() => v.list(s(r)));
  return c({
    ...t,
    queryKey: n,
    queryFn: async () => {
      const a = s(r);
      return e.landings.list(a);
    }
  });
}, C = (e, r, t) => {
  const n = i(() => m.list(s(r)));
  return c({
    ...t,
    queryKey: n,
    queryFn: async () => {
      const a = s(r);
      return e.landingGroups.list(a);
    }
  });
}, F = (e, r) => c({
  ...r,
  queryKey: d.all(),
  queryFn: async ({ signal: t }) => e.advertLabels.list(void 0, { signal: t })
});
export {
  d as advertLabelKeys,
  l as creativeGroupKeys,
  p as creativeKeys,
  m as landingGroupKeys,
  v as landingKeys,
  L as prefetchCreativeGroup,
  K as prefetchCreativeGroupList,
  F as useAdvertLabels,
  I as useCreativeGroup,
  q as useCreativeGroupList,
  f as useCreativeList,
  C as useLandingGroupList,
  A as useLandingList
};
//# sourceMappingURL=queries.js.map
